import { render, staticRenderFns } from "./ExpensesSidebar.vue?vue&type=template&id=70e5c195&scoped=true&"
import script from "./ExpensesSidebar.vue?vue&type=script&lang=js&"
export * from "./ExpensesSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ExpensesSidebar.vue?vue&type=style&index=0&id=70e5c195&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e5c195",
  null
  
)

export default component.exports